// Centralized country calling codes list (kept intentionally small to reduce bundle size)
// Label format: ISO2 (+code)
// Extend only as needed; prefer dynamic loading if list grows large.
export interface CountryCodeOption {
  iso2: string
  code: string
  label: string
}

export const COUNTRY_CODES: CountryCodeOption[] = [
  // Core SEA & nearby
  { iso2: 'MY', code: '+60', label: 'MY (+60)' },
  { iso2: 'SG', code: '+65', label: 'SG (+65)' },
  { iso2: 'TH', code: '+66', label: 'TH (+66)' },
  { iso2: 'VN', code: '+84', label: 'VN (+84)' },
  { iso2: 'ID', code: '+62', label: 'ID (+62)' },
  { iso2: 'PH', code: '+63', label: 'PH (+63)' },
  // North / North Asia
  { iso2: 'JP', code: '+81', label: 'JP (+81)' },
  { iso2: 'KR', code: '+82', label: 'KR (+82)' },
  { iso2: 'CN', code: '+86', label: 'CN (+86)' },
  { iso2: 'HK', code: '+852', label: 'HK (+852)' },
  { iso2: 'TW', code: '+886', label: 'TW (+886)' },
  // ANZ
  { iso2: 'AU', code: '+61', label: 'AU (+61)' },
  // Europe
  { iso2: 'GB', code: '+44', label: 'UK (+44)' },
  { iso2: 'DE', code: '+49', label: 'DE (+49)' },
  { iso2: 'FR', code: '+33', label: 'FR (+33)' },
  // Middle East
  { iso2: 'AE', code: '+971', label: 'AE (+971)' },
  { iso2: 'SA', code: '+966', label: 'SA (+966)' },
  // Americas & existing
  { iso2: 'US', code: '+1', label: 'US (+1)' },
  { iso2: 'IN', code: '+91', label: 'IN (+91)' },
]

// Potential future enhancements:
// - Add flags (emoji/SVG) e.g. { flag: '🇲🇾' }
// - Export a map for O(1) lookups: COUNTRY_CODE_MAP
// - Provide length constraints per country if stricter validation required
